import { AttendanceDetails } from './attendance-details.model';


export class EmployeeAttendanceDto implements IEmployeeAttendanceDto {
    attendanceDetails!: AttendanceDetails[] | undefined;
    totalPresentDays!: number;
    totalAbsentDays!: number;
    totalHalfLeavesDays!: number;
    totalLeaveDays!: number;
    totalMissingThumbDays!: number;
    totalHolidays!: number;

    constructor(data?: IEmployeeAttendanceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["attendanceDetails"])) {
                this.attendanceDetails = [] as any;
                for (let item of _data["attendanceDetails"])
                    this.attendanceDetails!.push(AttendanceDetails.fromJS(item));
            }
            this.totalPresentDays = _data["totalPresentDays"];
            this.totalAbsentDays = _data["totalAbsentDays"];
            this.totalHalfLeavesDays = _data["totalHalfLeavesDays"];
            this.totalLeaveDays = _data["totalLeaveDays"];
            this.totalMissingThumbDays = _data["totalMissingThumbDays"];
            this.totalHolidays = _data["totalHolidays"];
        }
    }

    static fromJS(data: any): EmployeeAttendanceDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeAttendanceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.attendanceDetails)) {
            data["attendanceDetails"] = [];
            for (let item of this.attendanceDetails)
                data["attendanceDetails"].push(item.toJSON());
        }
        data["totalPresentDays"] = this.totalPresentDays;
        data["totalAbsentDays"] = this.totalAbsentDays;
        data["totalHalfLeavesDays"] = this.totalHalfLeavesDays;
        data["totalLeaveDays"] = this.totalLeaveDays;
        data["totalMissingThumbDays"] = this.totalMissingThumbDays;
        data["totalHolidays"] = this.totalHolidays;
        return data; 
    }
}

export interface IEmployeeAttendanceDto {
    attendanceDetails: AttendanceDetails[] | undefined;
    totalPresentDays: number;
    totalAbsentDays: number;
    totalHalfLeavesDays: number;
    totalLeaveDays: number;
    totalMissingThumbDays: number;
    totalHolidays: number;
}

